import { render, staticRenderFns } from "./OrderPdfPage.vue?vue&type=template&id=8c5193b0"
import script from "./OrderPdfPage.vue?vue&type=script&lang=js"
export * from "./OrderPdfPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports